//
import { MainLayout } from "@/components/reusable_components/next"
import IndexView from "@/views/Index"

//
import RolesRoutes from "@/routes/RolesRoutes"

//
import GBankRoutes from "@/routes/General/GBank"
import GBranchOfficeRoutes from "@/routes/General/GBranchOffice"
import PosWorkstationUserRoutes from "@/routes/General/GPosWorkstationUser"
import QueryRoutes from "@/routes/General/GQuery"
import UserRoutes from "@/routes/General/GUser"
import PendingSalesRoutes from "@/routes/POS/PosPendingSales"
import PchPurchaseInvoice from "@/routes/Purchase/PchPurchaseInvoice"
import PosCashDesk from "@/routes/POS/PosCashDesk"
import PosCustomerReceivablePayment from "@/routes/POS/PosCustomerReceivablePayment"
import WhProductDeletedRoutes from "@/routes/Warehouse/WhProductDeleted"

//
export default [
    {
        path: "/",
        component: MainLayout,
        children: [

            // Default view
            {
                path: "",
                name: "index",
                component: IndexView,
            },

            // Root
            RolesRoutes,

            // General
            GBankRoutes,
            GBranchOfficeRoutes,
            PosWorkstationUserRoutes,
            QueryRoutes,
            UserRoutes,

            // Purchase
            PchPurchaseInvoice,

            // POS
            PendingSalesRoutes,
            PosCashDesk,
            PosCustomerReceivablePayment,

            // Warehouse
            WhProductDeletedRoutes,
        ],
        props: {
            breadcrumbsProps: {
                indexText: "TI",
            }
        },
    },
]
